import { render } from "./usercaseDialog.vue?vue&type=template&id=6f88dcfd&scoped=true"
import script from "./usercaseDialog.vue?vue&type=script&lang=js"
export * from "./usercaseDialog.vue?vue&type=script&lang=js"

import "./usercaseDialog.vue?vue&type=style&index=0&id=6f88dcfd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f88dcfd"]])

export default __exports__